import { Action, ActionLangChange } from "../action"

export interface ReduxState {
  notes: string[],
  langValue: string,


}

const initialState = {
  notes: [],
  langValue: "en",

}

export const reduxReducer = (state: ReduxState = initialState, action: Action) => {
  switch (action.type) {
    case "ADD_NOTE": {
      return { ...state, notes: [...state.notes, action.payload] };
    // case "LangChange": {
    //   console.log(action)
    //   return { ...state, langValue: action.payload };

    }
    default:
      return state
  }
}